import { FullWidthSpace } from "melco-ui";
import { useTranslation } from "react-i18next";
import { ReferencesListAlert } from "../../references/ReferencesListAlert";
import { useDesignReferences } from "../../../hooks/libraries/designs/useDesignReferences";
import { DesignMappingReferencesList } from "../../references/DesignMappingReferencesList";

type DesignReferencesListProps = {
  designId: string;
};

export const DesignReferencesList: React.FC<DesignReferencesListProps> = ({
  designId,
}) => {
  const { t } = useTranslation();

  const { data: designReferences } = useDesignReferences(designId);

  return (
    <FullWidthSpace direction="vertical" size="large">
      <ReferencesListAlert message={t("designs.actions.references.warning")} />
      <DesignMappingReferencesList
        designMappingList={designReferences?.mapping_list ?? undefined}
      />
    </FullWidthSpace>
  );
};
